module.exports = __webpack_public_path__ + "img/inspiration@2x.d2268ad.webp";